const searchLabel = (label: string, searchQuery: string) =>
  searchQuery === ''
    ? true
    : searchQuery
        .toLowerCase()
        .split(' ')
        .every((word) => label.toLowerCase().includes(word));
export default searchLabel;
